import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
// core components
import Header from "dashboard/hr-management/components/Headers/Header";
import Select from "react-select";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { api } from "../../../../api";
import Cookies from "js-cookie";

const Editproject3 = () => {

  const {id} = useParams();

  const [editemp , seteditemp] = useState({
    emp_id : id,
    emp_name : "",
    email : "",
    phoneno : "",
    dob : "",
    doj : "",
    salary : "",
    role : "",
    department : '',
    address : "",
    files : ''
  });

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const [role, setrole] = useState();
  const [department, setdepartment] = useState();

  // Fetch roles only (departments are fetched in the main useEffect)
  useEffect(() => {
    const company_id = Cookies.get('company_id');
    api.get("addRole.php?company_id=" + company_id).then((res) => {
      setrole(res.data);
    });
  }, []);

  useEffect(() => {
    // Fetch department list first
    api.get("department.php?company_id=" + Cookies.get('company_id')).then((deptRes) => {
      setdepartment(deptRes.data);
      // Now fetch employee details
      api.get("employeesView.php?get_id=" + id).then((res) => {
        // Find the department name for this employee
        let deptName = '';
        if (res.data[0].department || res.data[0].dept) {
          const found = deptRes.data.find(
            (d) => d.d_id == res.data[0].department || d.d_id == res.data[0].dept || d.dept_name === res.data[0].department
          );
          deptName = found ? found.dept_name : '';
        }
        seteditemp({
          ...editemp,
          emp_name: res.data[0].emp_name,
          email: res.data[0].email,
          phoneno: res.data[0].phoneno,
          dob: res.data[0].dob, // Set dob from correct field
          doj: res.data[0].doj,
          salary: res.data[0].salary,
          role: res.data[0].role,
          department: deptName, // Use department name here!
          address: res.data[0].address,
          files: res.data[0].profile_image
        });
        setProfileImage({
          oldimage: res.data[0].profile_image
        });
      });
    });
  }, [id]);
    
    console.log(editemp)

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    seteditemp((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    console.log(editemp)
  };

  const [profileImage, setProfileImage] = useState({
    oldimage : ""
  });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        seteditemp((prevState) => ({
            ...prevState,
            files: file,
            profile_image: file.name // assuming you want to update profile_image with the filename
        }));
    }
};


  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    // Validate that Site Managers have a department assigned
    if (editemp.role === "Site Manager" && !editemp.department) {
      setSuccessMessage('Site Managers must be assigned to a department.');
      setShowSuccessAlert(true);
      return;
    }
        
        const formDataToSend = new FormData();
        formDataToSend.append('emp_id', editemp.emp_id);
        formDataToSend.append('emp_name', editemp.emp_name);
        formDataToSend.append('email', editemp.email);
        formDataToSend.append('phoneno', editemp.phoneno);
        formDataToSend.append('dob', editemp.dob);
        formDataToSend.append('doj', editemp.doj);
        formDataToSend.append('role', editemp.role);
        formDataToSend.append('department', editemp.department);
        formDataToSend.append('salary', editemp.salary);
        formDataToSend.append('address', editemp.address);
        formDataToSend.append('files', editemp.files);
        formDataToSend.append('company_id', Cookies.get('company_id'));

        try {
        const response = await api.post("editEmployee.php",formDataToSend);
        console.log("Data sent successfully:", response.data);
        setSuccessMessage('Employee updated successfully!');
        setShowSuccessAlert(true);
        } catch (error) {
        console.error("Error submitting data:", error);
        setSuccessMessage('Error updating employee. Please try again.');
        setShowSuccessAlert(true);
        }
  };


  return (
    <>
      <div className="header bg-gradient-info py-6 py-lg-7">
        <Container className="py-4" style={{ maxWidth: '800px' }}>
          <div
            className="p-4 rounded"
            style={{
              backgroundColor: "white",
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
              border: "1px solid black",
            }}
          >
            <Link to="/hr-admin/hr-management/employees3">
              {" "}
              <Button style={{ backgroundColor: '#F08080', borderColor: '#F08080', color: 'black' }} className="ml-2">Back</Button>
            </Link>
            <Col className="order-xl-2 mb-5 mb-xl-0 text-center  mb-5">
              <h1 className="mb-5">Edit Employee Details</h1>
            </Col>
            <Form onSubmit={handleFormSubmit}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-name">
                      Employee Name *
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-name"
                      type="text"
                      name="emp_name"
                      value={editemp.emp_name}
                      onChange={handleInputChange}
                      placeholder="Enter Employee Name"
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-number">
                      Contact Number *
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-number"
                      type="text"
                      name="phoneno"
                      value={editemp.phoneno}
                      placeholder="Enter Contact Number"
                      pattern="[0-9]{10}"
                      title="Enter 10 digits only"
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-email">
                      Email Id *
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-mail"
                      type="email"
                      name="email"
                      value={editemp.email}
                      onChange={handleInputChange}
                      placeholder="Enter Email Address"
                      pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}"
                      title="Enter valid email address"
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-birthday">
                      Date of Birth *
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-birthday"
                      type="date"
                      name="dob"
                      value={editemp.dob}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-manager">
                      Select Role *
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-manager"
                      type="select"
                      name="role"
                      value={editemp.role}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Role</option>
                      {role && Array.isArray(role) &&
                        role.map((option) => (
                          <option key={option.role_name} value={option.role_name}>
                            {option.role_name}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-department">
                      Select Department {editemp.role === "Site Manager" && "*"}
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-department"
                      type="select"
                      name="department"
                      value={editemp.department || ''}
                      onChange={handleInputChange}
                      required={editemp.role === "Site Manager"}
                    >
                      <option value="">Select Department</option>
                      {department && Array.isArray(department) &&
                        department.map((option) => (
                          <option key={option.d_id} value={option.dept_name}>
                            {option.dept_name}
                          </option>
                        ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-joining">
                      Date of Joining *
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-joining"
                      type="date"
                      name="doj"
                      value={editemp.doj}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-salary">
                      Salary *
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-salary"
                      type="number"
                      name="salary"
                      value={editemp.salary}
                      onChange={handleInputChange}
                      placeholder="Enter Salary"
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-file">
                      Upload Image *
                    </label>
                    <Input
                      type="file"
                      className="form-control"
                      id="input-file"
                      name="profile_image"
                      onChange={handleFileChange}
                    />
                    {profileImage && profileImage.oldimage && (
                      <small className="form-text text-muted">Old Image: {profileImage.oldimage}</small>
                    )}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label className="form-control-label" htmlFor="input-location">
                      Address *
                    </label>
                    <Input
                      className="form-control-alternative"
                      id="input-location"
                      type="text"
                      name="address"
                      value={editemp.address}
                      onChange={handleInputChange}
                      placeholder="Location"
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg="12" style={{ textAlign: "center" }}>
                  <Button style={{ backgroundColor: '#F08080', borderColor: '#F08080', color: 'black' }} type="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Container>
      </div>
      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => {
                setShowSuccessAlert(false);
                window.location.reload();
              }}
            >OK</Button>
          </div>
        </div>
      )}
    </>
  );
};

export default Editproject3;
